import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Location, RideRequestLocation } from '@uzurv/clara';
import * as LocationManagerActions from '../../../store/location-manager/location-manager.actions';

export interface LocationManagerDialogData {
  title: string;
  preloadedLocation: Location;
}

@Component({
  selector: 'app-location-manager-dialog',
  templateUrl: 'location-manager-dialog.component.html',
  styleUrls: ['location-manager-dialog.component.scss']
})
export class LocationManagerDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<LocationManagerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LocationManagerDialogData,
    private store$: Store
  ) {}

  select(rideRequestLocation: RideRequestLocation) {
    this.dialogRef.close(rideRequestLocation);
    this.store$.dispatch(LocationManagerActions.Reset());
  }

  close(): void {
    this.dialogRef.close();
  }
}
